export class URLBuilder {
  constructor(url) {
    this.url = url;
    this.params = {};
  }
  withQueryParam(key, value) {
    this.params[key] = value;
    return this;
  }
  build() {
    const filteredParams = Object.entries(this.params).filter(([, value]) => value !== undefined && value !== null && value !== '').map(([key, value]) => [key, value && value.toString()]);
    const queryInstance = new URLSearchParams(filteredParams);
    const queryParams = queryInstance.toString();
    if (queryParams === '') {
      return `${this.url}`;
    }
    if (queryParams) {
      return `${this.url}?${queryParams}`;
    }
    return this.url;
  }
}